import { render, staticRenderFns } from "./BranchAdd.vue?vue&type=template&id=64504e0f&scoped=true"
import script from "./BranchAdd.vue?vue&type=script&lang=js"
export * from "./BranchAdd.vue?vue&type=script&lang=js"
import style0 from "./BranchAdd.vue?vue&type=style&index=0&id=64504e0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64504e0f",
  null
  
)

export default component.exports